export const FAMILY_APPLICATION_STEPS = {
  START: 'start',
  CONTACT_INFORMATION: 'contact',
  LOCATION_INFORMATION: 'location',
  BRANCH_OF_SERVICE: 'branch-of-service',
  COMPONENT: 'component',
  STATUS: 'status',
  RANK: 'rank',
  CIVILIAN_EMPLOYMENT: 'civilian-employment',
  MARITAL_STATUS: 'marital-status',
  DOCUMENTS: 'documents',
  HOUSEHOLD_STRUCTURE: 'household-structure',
  SPOUSE_RESIDENCE_STATUS: 'spouse-residence-status',
  EMPLOYMENT_ACTIVITIES: 'employment-activities',
  SPOUSE_EMPLOYMENT_TYPE: 'spouse-employment-type',
  SPOUSE_EMPLOYER_DETAILS: 'spouse-employer-details',
  SPOUSE_SELF_EMPLOYMENT: 'spouse-self-employment',
  SPOUSE_MILITARY_EMPLOYMENT: 'spouse-military-employment',
  SPOUSE_JOB_SEARCH: 'spouse-job-search',
  SPOUSE_UNEMPLOYMENT_REASON: 'spouse-unemployment-reason',
  SPOUSE_EDUCATION: 'spouse-education',
  SPOUSE_DOCUMENTATION_REQUIREMENTS: 'spouse-documentation-requirements',
  ELIGIBILITY_SUMMARY: 'eligibility-summary',
  SPOUSE_CONTACT_INFO: 'spouse-contact-info',
  CHILDREN_BASIC_INFO: 'children-basic-info',
  CHILDREN_LIVING_SITUATION: 'children-living-situation',
  CHILDREN_EDUCATIONAL_STATUS: 'children-educational-status',
  CHILDREN_PROVIDER_CONNECTION: 'children-provider-connection',
  CHILDREN_PROVIDER_INFO: 'children-provider-info',
  CHILDREN_CHILD_CARE_NEEDS: 'children-child-care-needs',
  CHILDREN_CARE_NEED_TYPE: 'children-care-need-type',
  CHILDREN_SCHEDULE_OF_CARE: 'children-schedule-of-care',
  CHILDREN_DAILY_TIME_BLOCKS: 'children-daily-time-blocks',
  CHILDREN_SUMMARY: 'children-summary',
  CHILDREN_ELIGIBILITY_CERTIFICATION: 'children-eligibility-certification',
  CHILDREN_DOCUMENTS: 'children-documents',
  DOCUMENTATION_REQUIREMENTS: 'documentation-requirements',
  AGREEMENT: 'agreement',
  SUBMITTED: 'submitted',
};

export const FAMILY_APPLICATION_STEPS_ORDER = [
  FAMILY_APPLICATION_STEPS.START,
  FAMILY_APPLICATION_STEPS.MARITAL_STATUS,
  FAMILY_APPLICATION_STEPS.CONTACT_INFORMATION,
  FAMILY_APPLICATION_STEPS.LOCATION_INFORMATION,
  FAMILY_APPLICATION_STEPS.COMPONENT,
  FAMILY_APPLICATION_STEPS.STATUS,
  FAMILY_APPLICATION_STEPS.RANK,
  FAMILY_APPLICATION_STEPS.CIVILIAN_EMPLOYMENT,
  FAMILY_APPLICATION_STEPS.DOCUMENTS,
  FAMILY_APPLICATION_STEPS.HOUSEHOLD_STRUCTURE,
  FAMILY_APPLICATION_STEPS.SPOUSE_CONTACT_INFO,
  FAMILY_APPLICATION_STEPS.SPOUSE_RESIDENCE_STATUS,
  FAMILY_APPLICATION_STEPS.EMPLOYMENT_ACTIVITIES,
  FAMILY_APPLICATION_STEPS.SPOUSE_EMPLOYMENT_TYPE,
  FAMILY_APPLICATION_STEPS.SPOUSE_EMPLOYER_DETAILS,
  FAMILY_APPLICATION_STEPS.SPOUSE_SELF_EMPLOYMENT,
  FAMILY_APPLICATION_STEPS.SPOUSE_MILITARY_EMPLOYMENT,
  FAMILY_APPLICATION_STEPS.SPOUSE_EDUCATION,
  FAMILY_APPLICATION_STEPS.ELIGIBILITY_SUMMARY,
  FAMILY_APPLICATION_STEPS.SPOUSE_UNEMPLOYMENT_REASON,
  FAMILY_APPLICATION_STEPS.SPOUSE_JOB_SEARCH,
  FAMILY_APPLICATION_STEPS.SPOUSE_DOCUMENTATION_REQUIREMENTS,
  FAMILY_APPLICATION_STEPS.CHILDREN_BASIC_INFO,
  FAMILY_APPLICATION_STEPS.CHILDREN_LIVING_SITUATION,
  FAMILY_APPLICATION_STEPS.CHILDREN_EDUCATIONAL_STATUS,
  FAMILY_APPLICATION_STEPS.CHILDREN_PROVIDER_CONNECTION,
  FAMILY_APPLICATION_STEPS.CHILDREN_PROVIDER_INFO,
  FAMILY_APPLICATION_STEPS.CHILDREN_CHILD_CARE_NEEDS,
  FAMILY_APPLICATION_STEPS.CHILDREN_CARE_NEED_TYPE,
  FAMILY_APPLICATION_STEPS.CHILDREN_SCHEDULE_OF_CARE,
  FAMILY_APPLICATION_STEPS.CHILDREN_DAILY_TIME_BLOCKS,
  FAMILY_APPLICATION_STEPS.CHILDREN_SUMMARY,
  FAMILY_APPLICATION_STEPS.CHILDREN_ELIGIBILITY_CERTIFICATION,
  FAMILY_APPLICATION_STEPS.CHILDREN_DOCUMENTS,
  FAMILY_APPLICATION_STEPS.DOCUMENTATION_REQUIREMENTS,
  FAMILY_APPLICATION_STEPS.AGREEMENT,
  FAMILY_APPLICATION_STEPS.SUBMITTED,
];

export const FAMILY_BRANCH_MAP = {
  army: {
    id: 2,
    title: 'Army',
    description: 'U.S. Army, including Army National Guard and Army Reserve',
    active: true,
    sequenceNumber: 1,
  },
  airForce: {
    id: 1,
    title: 'Air Force',
    description: 'U.S. Air Force, including Air National Guard and Air Force Reserve',
    active: true,
    sequenceNumber: 2,
  },
  marineCorps: {
    id: 3,
    title: 'Marine Corps',
    description: 'U.S. Marine Corps, including Marine Corps Reserve',
    active: true,
    sequenceNumber: 3,
  },
  spaceForce: {
    id: 8,
    title: 'Space Force',
    description: 'U.S. Space Force, the newest branch of the Armed Forces',
    active: true,
    sequenceNumber: 4,
  },
  navy: {
    id: 4,
    title: 'Navy',
    description: 'U.S. Navy',
    active: false,
    sequenceNumber: 5,
  },
  costGuard: {
    id: 9,
    title: 'Coast Guard',
    description: 'U.S. Coast Guard',
    active: false,
    sequenceNumber: 6,
  },
  departmentOfDefense: {
    id: 10,
    title: 'Department of Defense',
    description: 'Department of Defense',
    active: false,
    sequenceNumber: 7,
  },
};

/*
 * This is the list of branches of service that are available for selection
 * in the Family Application. The list is used to populate the radio buttons
 * in the Branch of Service step of the application.
 */
export const FAMILY_BRANCH_ARRAY = [
  FAMILY_BRANCH_MAP.army,
  FAMILY_BRANCH_MAP.airForce,
  FAMILY_BRANCH_MAP.marineCorps,
  FAMILY_BRANCH_MAP.spaceForce,
];

export const FAMILY_COMPONENT_MAP = {
  activeDuty: {
    id: 1,
    title: 'Active Duty',
    description: 'Full-time military service',
    descriptionBasedOnBranch: {
      completedBySponsor: {
        [FAMILY_BRANCH_MAP.army.id]: 'In the Army (full-time)',
        [FAMILY_BRANCH_MAP.airForce.id]: 'In the Air Force full-time',
        [FAMILY_BRANCH_MAP.marineCorps.id]: 'In the Marine Corps full-time',
        [FAMILY_BRANCH_MAP.spaceForce.id]: 'In the Space Force full-time',
      },
      completedOnBehalfOfSponsor: {
        [FAMILY_BRANCH_MAP.army.id]: 'In the Army full-time',
        [FAMILY_BRANCH_MAP.airForce.id]: 'In the Air Force full-time',
        [FAMILY_BRANCH_MAP.marineCorps.id]: 'In the Marine Corps full-time',
        [FAMILY_BRANCH_MAP.spaceForce.id]: 'In the Space Force full-time',
      },
    },
  },
  nationalGuard: {
    id: 3,
    title: 'National Guard',
    description: 'National Guard service',
    descriptionBasedOnBranch: {
      completedBySponsor: {
        [FAMILY_BRANCH_MAP.army.id]: "I'm in the Army National Guard",
        [FAMILY_BRANCH_MAP.airForce.id]: "I'm in the Air National Guard",
      },
      completedOnBehalfOfSponsor: {
        [FAMILY_BRANCH_MAP.army.id]: 'In the Army National Guard',
        [FAMILY_BRANCH_MAP.airForce.id]: 'In the Air National Guard',
      },
    },
  },
  reserve: {
    id: 4,
    title: 'Reserve',
    description: 'Reserve military service',
    descriptionBasedOnBranch: {
      completedBySponsor: {
        [FAMILY_BRANCH_MAP.army.id]: "I'm in the Army Reserve",
        [FAMILY_BRANCH_MAP.airForce.id]: "I'm in the Air Force Reserve",
        [FAMILY_BRANCH_MAP.marineCorps.id]: "I'm in the Marine Corps Reserve",
      },
      completedOnBehalfOfSponsor: {
        [FAMILY_BRANCH_MAP.army.id]: 'In the Army Reserve',
        [FAMILY_BRANCH_MAP.airForce.id]: 'In the Air Force Reserve',
        [FAMILY_BRANCH_MAP.marineCorps.id]: 'In the Marine Corps Reserve',
      },
    },
  },
  civilianEmployee: {
    id: 2,
    title: 'Civilian Employee',
    titleBasedOnBranch: {
      [FAMILY_BRANCH_MAP.army.id]: 'Civilian Employee',
      [FAMILY_BRANCH_MAP.airForce.id]: 'Civilian',
      [FAMILY_BRANCH_MAP.marineCorps.id]: 'Civilian',
      [FAMILY_BRANCH_MAP.spaceForce.id]: 'Civilian',
    },
    description: 'Civilian employee (not in the military)',
  },
};

export const FAMILY_STATUS_MAP = {
  activated: {
    id: 1,
    title: 'Activated',
    description:
      'Currently serving on full-time active duty orders (30+ consecutive days). You must provide these orders with your application',
    sequenceNumber: 1,
  },
  civilianEmployee: {
    id: 4,
    title: 'Civilian Employee',
    description: 'Department of Defense civilian employee',
    sequenceNumber: 4,
  },
  deployed: {
    id: 5,
    title: 'Deployed',
    description:
      'Currently serving away from permanent duty station on operational orders. Your LES typically shows Hostile Fire Pay, Family Separation Allowance, or tax exclusions',
    sequenceNumber: 6,
  },
  defenseHealthAgency: {
    id: 6,
    title: 'Defense Health Agency (DHA)',
    description: 'Health care professional practicing alongside civilian and military personnel',
    sequenceNumber: 5,
  },
  dualStatusTechnician: {
    id: 7,
    title: 'Dual-Status Technician (Activated)',
    description: 'Normally a military technician (civilian) but currently serving on active duty orders',
    sequenceNumber: 7,
  },
  dualStatusTechnicianCurrentlyCivilian: {
    id: 8,
    title: 'Dual-Status Technician (Currently Civilian)',
    description: 'Employed as a civilian military technician during the week, serving in Guard/Reserve part-time',
    sequenceNumber: 9,
  },
  nonDeployed: {
    id: 12,
    title: 'Non-Deployed',
    description: 'Serving at your assigned duty station, not currently on deployment orders',
    sequenceNumber: 12,
  },
  weekendDrill: {
    id: 13,
    title: 'Weekend Drill',
    description: 'Weekend Drill',
    sequenceNumber: 13,
  },
  woundedWarriorInTransition: {
    id: 14,
    title: 'Wounded Warrior In Transition',
    description: 'Guard/Reserve member with documented combat-related injuries from military operations',
    sequenceNumber: 14,
  },
  goldStarSpouse: {
    id: 16,
    title: 'Gold Star Spouse (Combat Related)',
    description: 'Husband or wife whose spouse passed away while serving in the U.S. military during combat',
    sequenceNumber: 15,
  },
};

/*
 * This function finds a component of service by its ID in the FAMILY_COMPONENT_ARRAY
 * @param {number} id - The ID of the component to find.
 * @returns {object} - The component object if found, otherwise undefined.
 */
export const getComponentById = (id) => {
  return Object.values(FAMILY_COMPONENT_MAP).find((component) => component.id === id);
};

export const FAMILY_APPLICATION_SPONSOR_TYPE = {
  MILITARY: 'Military',
  CIVILIAN: 'Civilian',
  DUAL_STATUS: 'Dual Status',
};

export const FAMILY_NON_DEPLOYMENT_TYPES_MAP = {
  basicTraining: {
    id: 4,
    name: 'Basic Training',
    description: 'Currently attending initial military training upon joining the service',
    deployed: false,
  },
  regularDuty: {
    id: 5,
    name: 'Regular Duty',
    description: 'Regular duty at their assigned station',
    deployed: false,
  },
};

export const FAMILY_SPOUSE_EDUCATION_LEVELS = {
  UNDERGRADUATE: 'Undergrad',
  GRADUATE: 'Graduate',
  OTHER_POST_SECONDARY: 'OtherPostSecondary',
};

export const CHILD_RELATIONSHIP_OPTIONS_MAP = {
  child: {
    id: 1,
    title: 'Child',
    value: 'Child',
    description: 'Child born to the Military Sponsor',
  },
  stepchild: {
    id: 2,
    title: 'Stepchild',
    value: 'Stepchild',
    description: "Child of the Military Sponsor's spouse or partner",
  },
  fosterChild: {
    id: 4,
    title: 'Foster Child',
    value: 'FosterChild',
    description: 'Child placed in foster care with the Military Sponsor',
  },
  legalGuardian: {
    id: 3,
    title: 'Legal Guardian/Ward',
    value: 'LegalGuardian',
    description: 'Legal Guardian/Ward',
  },
};
export const CHILD_RELATIONSHIP_OPTIONS = [
  CHILD_RELATIONSHIP_OPTIONS_MAP.child,
  CHILD_RELATIONSHIP_OPTIONS_MAP.stepchild,
  CHILD_RELATIONSHIP_OPTIONS_MAP.fosterChild,
  CHILD_RELATIONSHIP_OPTIONS_MAP.legalGuardian,
];

export const CHILD_GRADE_LEVELS = [
  { value: 'PreK', label: 'Pre-K' },
  { value: 'Kindergarten', label: 'Kindergarten' },
  { value: 'First', label: 'First' },
  { value: 'Second', label: 'Second' },
  { value: 'Third', label: 'Third' },
  { value: 'Fourth', label: 'Fourth' },
  { value: 'Fifth', label: 'Fifth' },
  { value: 'Sixth', label: 'Sixth' },
  { value: 'Seventh', label: 'Seventh' },
  { value: 'Eighth', label: 'Eighth' },
];

export const CHILD_PROVIDER_SITUATION_VALUES = {
  InCare: 'InCare',
  ProviderIdentified: 'ProviderIdentified',
  ReferralNeeded: 'ReferralNeeded',
};
export const CHILD_PROVIDER_SITUATION_OPTIONS = [
  {
    value: CHILD_PROVIDER_SITUATION_VALUES.InCare,
    label: {
      completedBySponsor: "I'm already paying for child care",
      completedOnBehalfOfSponsor: 'Already paying for child care',
    },
    description: {
      completedBySponsor: 'My child currently attends a provider and I pay regularly',
      completedOnBehalfOfSponsor: 'The child currently attends a provider and the service member pays regularly',
    },
  },
  {
    value: CHILD_PROVIDER_SITUATION_VALUES.ProviderIdentified,
    label: {
      completedBySponsor: "I've chosen a provider but haven't started care yet",
      completedOnBehalfOfSponsor: "We have chosen a provider but haven't started care yet",
    },
    description: {
      completedBySponsor: "I've selected a provider but my child hasn't started attending",
      completedOnBehalfOfSponsor: "The service member has selected a provider but the child hasn't started attending",
    },
  },
  {
    value: CHILD_PROVIDER_SITUATION_VALUES.ReferralNeeded,
    label: {
      completedBySponsor: 'I need help finding a provider',
      completedOnBehalfOfSponsor: 'Need help finding a provider',
    },
    description: {
      completedBySponsor: 'I need assistance locating available child care in my area',
      completedOnBehalfOfSponsor: 'The service member needs assistance locating available child care in their area',
    },
  },
];

/**
 * Order title options for the Family Application.
 * Each entry: id, label (when completed by sponsor), and componentIds (FAMILY_COMPONENT_MAP ids that show this option).
 */
export const ORDER_TITLE_MAP = {
  title10: {
    id: 1,
    label: 'Federal orders (Title 10)',
    componentIds: [FAMILY_COMPONENT_MAP.nationalGuard.id, FAMILY_COMPONENT_MAP.reserve.id],
  },
  title32: {
    id: 2,
    label: 'Federal orders (Title 32)',
    componentIds: [FAMILY_COMPONENT_MAP.nationalGuard.id],
  },
  notSure: {
    id: 4,
    label: 'Not sure',
    componentIds: [FAMILY_COMPONENT_MAP.nationalGuard.id, FAMILY_COMPONENT_MAP.reserve.id],
  },
};

export const FAMILY_IMPORT_STATUS_MAP = {
  SUCCESS: {
    value: 'SUCCESS',
    label: 'Success',
    description: 'Successfully imported to legacy system',
  },
  FAILURE: {
    value: 'FAILURE',
    label: 'Failure',
    description: 'Failed to import to legacy system',
  },
  NOT_FOUND: {
    value: 'NOT_FOUND',
    label: 'Pending',
    description: 'Not yet imported to legacy system',
  },
  DUPE_FOUND: {
    value: 'DUPE_FOUND',
    label: 'Duplicate',
    description: 'Duplicate record found in legacy system',
  },
};
